module.exports = __webpack_public_path__ + "static/media/262533.fd2f637d.jpg";